import SolarIcon from 'components/icons/SolarIcon';
const TableHeadTdOrder = ({title, fieldName, value, desc=false, onClick,
        className="cursor-pointer d-flex align-items-center"
    }) => {
        
    return (<>
        <span className={className}
            onClick={()=>{
                onClick(fieldName, (value == fieldName) ? !desc : false);
            }}>
            {title} 

            {value == fieldName && (
                <SolarIcon name={desc ? 'caret-up-fill' : 'caret-down-fill'} className="fs-18 p-0 ms-1 text-muted" />)}

            </span>
    </>)
}

export default TableHeadTdOrder; 
